/*core module*/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { APP_INITIALIZER } from '@angular/core';

/*project Component*/
import { AppComponent, HtmlreaderDirectiveHeader, HtmlreaderDirectiveFooter } from './app.component';
/*configuration file for the external json*/
import { ConfigService } from './config.service';
import { ConfigLoader } from './config-loader';

/**********************************************/
/*related to this specific project*/
import { TreeViewComponent, PageCategoryTitleComponent} from './treeView.component';
import { ContentListComponent } from './content-list.component';

import {LoadingContainer, LoadingPage} from	'./loading-container';


/*plug in*/
/************** ** */

//import { RouterModule, Routes } from '@angular/router';

//const appRoutes: Routes = [
//	{ path: ':catId', redirectTo: '/index2.html', pathMatch: 'full' }
//];


@NgModule({
	declarations: [
		HtmlreaderDirectiveHeader, HtmlreaderDirectiveFooter, 
		AppComponent, TreeViewComponent, ContentListComponent, PageCategoryTitleComponent,
		LoadingContainer
  ],
  imports: [
	//RouterModule.forRoot(appRoutes),
	BrowserModule,
	HttpModule
  ],
  providers: [
	  ConfigService,
	  {
		  provide: APP_INITIALIZER,
		  useFactory: ConfigLoader,
		  deps: [ConfigService],
		  multi: true
	  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts